import React from 'react';
import { motion } from 'framer-motion';
import { Search, BarChart3, Users, Bot, Zap, RefreshCw } from 'lucide-react';
const capabilities = [{
  name: 'Google Ads',
  icon: Search
}, {
  name: 'Google Analytics',
  icon: BarChart3
}, {
  name: 'CRM',
  icon: Users
}, {
  name: 'IA',
  icon: Bot
}, {
  name: 'Automatización',
  icon: Zap
}, {
  name: 'Remarketing',
  icon: RefreshCw
}];
export function Trust() {
  return <section id="confianza" className="py-16 bg-slate-50 border-y border-slate-100" data-id="element-246">
      <div className="container mx-auto px-6 md:px-12" data-id="element-247">
        <div className="text-center mb-10" data-id="element-248">
          <h2 className="text-xl md:text-2xl font-semibold text-slate-500" data-id="element-249">
            Empresas que quieren crecer eligen procesos inteligentes.
          </h2>
        </div>

        <div className="flex flex-wrap justify-center gap-6 md:gap-12 items-center opacity-70" data-id="element-250">
          {capabilities.map((cap, index) => {
          const Icon = cap.icon;
          return <motion.div key={cap.name} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-center gap-2 text-slate-600 grayscale hover:grayscale-0 hover:text-brand-cyan transition-all duration-300 cursor-default" data-id="element-251">
                <Icon size={24} data-id="element-252" />
                <span className="font-semibold text-lg" data-id="element-253">{cap.name}</span>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}